"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _reactCountryRegionSelector = require("react-country-region-selector");

var _ = require("./..");

var _Form = require("../Form");

var _i18n = require("../../i18n");

var _utils = require("../../../utils");

var CountryRegionFieldSet = function CountryRegionFieldSet(_ref) {
  var variant = _ref.variant,
      value = _ref.value,
      _onChange = _ref.onChange,
      error = _ref.error,
      countryDropdownOptions = _ref.countryDropdownOptions,
      regionDropdownOptions = _ref.regionDropdownOptions;

  var _useIntl = (0, _i18n.useIntl)({
    scope: 'components.CountryRegionFieldSet',
    ignoreGlobalScope: true
  }),
      msg = _useIntl.msg;

  return /*#__PURE__*/_react.default.createElement(_.FieldSet, {
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_.FieldWrapper, {
    label: msg({
      id: 'country.label',
      defaultMessage: 'Country'
    }),
    fieldType: "Select",
    iconAfter: "fas fa-caret-down",
    variant: variant,
    error: !value.country ? error : null
  }, /*#__PURE__*/_react.default.createElement(_reactCountryRegionSelector.CountryDropdown, (0, _extends2.default)({
    valueType: "short",
    value: value.country || '',
    onChange: function onChange(country) {
      _onChange({
        country: country,
        region: null
      });
    }
  }, countryDropdownOptions, {
    defaultOptionLabel: msg({
      id: 'country.defaultOption',
      defaultMessage: 'Select a country'
    })
  }))), /*#__PURE__*/_react.default.createElement(_.FieldWrapper, {
    label: msg({
      id: 'region.label',
      defaultMessage: 'Region'
    }),
    fieldType: "Select",
    iconAfter: "fas fa-caret-down",
    variant: variant,
    error: !value.region ? error : null
  }, /*#__PURE__*/_react.default.createElement(_reactCountryRegionSelector.RegionDropdown, (0, _extends2.default)({
    country: value.country,
    countryValueType: "short",
    value: value.region || '',
    onChange: function onChange(region) {
      _onChange({
        country: value.country,
        region: region
      });
    }
  }, regionDropdownOptions, {
    defaultOptionLabel: msg({
      id: 'region.defaultOption',
      defaultMessage: 'Select a region'
    })
  }))));
};

CountryRegionFieldSet.propTypes = {
  variant: _propTypes.default.oneOfType([_propTypes.default.oneOf(['fill', 'outline', 'clear']), _propTypes.default.string]),
  value: _propTypes.default.shape({
    country: _propTypes.default.string,
    region: _propTypes.default.string
  }),
  countryDropdownOptions: _propTypes.default.object,
  regionDropdownOptions: _propTypes.default.object,
  onChange: _propTypes.default.func,
  required: _propTypes.default.bool,
  error: _propTypes.default.string
};
CountryRegionFieldSet.defaultProps = {
  variant: 'fill',
  onChange: function onChange() {
    return null;
  },
  value: {},
  countryDropdownOptions: {},
  regionDropdownOptions: {}
};
CountryRegionFieldSet.displayName = 'CountryRegionFieldSet';

var _default = (0, _recompose.withProps)(function (props) {
  return (0, _extends2.default)({}, props.required ? {
    rules: [function (_ref2) {
      var value = _ref2.value;
      return !(0, _utils.isEmpty)(value) && !(0, _utils.isEmpty)(value.country) && !(0, _utils.isEmpty)(value.region) || (0, _i18n.msg)({
        id: 'components.form.rules.required',
        defaultMessage: 'Required field!'
      });
    }]
  } : {});
})((0, _Form.formalizer)(CountryRegionFieldSet));

exports.default = _default;